import api from './api'

export default class DeleteRequest {
  url: string

  body: unknown
  headers: any = {}
  timeout: number | undefined

  constructor(url: string, body?: unknown, headers?: any, timeout?: number) {
    this.url = url
    this.body = body
    this.headers = headers
    this.timeout = timeout
  }

  async run() {
    const headers = { ...this.headers }
    return api.delete(this.url, { data: this.body, headers, timeout: this.timeout })
  }
}
